import {Service} from "@/services/superclasses/service";
import {PostList} from "@/interfaces/post-list";

const api = window.contextPath + '/rest/posts';

export class PostService extends Service {

    public mlt = async (
        id: number,
        first?: number,
        max?: number
    ): Promise<PostList[]> => {
        return this.data(await this.get<PostList[]>(api + "/mlt/" + id,
            {
                params: {
                    first: first,
                    max: max
                }
            }))
    }

    public search = async (args: {
        type: Array<number>,
        member?: number,
        q?: string,
        first?: number,
        max?: number
    }): Promise<PostList[]> => {
        return this.data(await this.get<PostList[]>(api + "/",
            {
                params: args
            }))
    }
}

export const postService = new PostService()